import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import Editor from "../src/components/Editor";
import { CropperRefsProvider } from "./Context/CropperContext";
import { ImageCropperProvider } from "./Context/ImageCropper";
import { ModalProvider } from "./Context/ModalContext";
import store from "./store";
import "./assets/style/custom.css";
import "./assets/style/font.css";
import "./assets/style/modal.css";
import "bootstrap/dist/css/bootstrap.min.css";

export function loadInPageMultimgEditor(
  containerId: string /* , orient: string, preloadCard: string, carteId: string, photoId: string */
) {
  const MODE = "development"
  {
    MODE === "development" ? window.store = store : "";
  }

  const rootElement = document.getElementById(containerId);
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
      <ModalProvider>
        <ImageCropperProvider>
          <CropperRefsProvider>
          <Provider store={store}>
            <Editor
            />
          </Provider>
          </CropperRefsProvider>
        </ImageCropperProvider>
      </ModalProvider>
    );
  } else {
    console.error(`L'élément avec l'ID "${containerId}" n'a pas été trouvé.`);
  }
}
